export enum CommonActionType {
  FETCH_ORDER_REVIEW = 'FETCH_ORDER_REVIEW',
  FETCH_SHIPMENT_PLACES_LIST = 'FETCH_SHIPMENT_PLACES_LIST',
  FETCH_ORDER_TRANSPORT_TYPES_LIST = 'FETCH_ORDER_TRANSPORT_TYPES_LIST',
  FETCH_ORDER_STATUS_LIST = 'FETCH_ORDER_STATUS_LIST',
  FETCH_ORDER_STATUS_LIST_IT = 'FETCH_ORDER_STATUS_LIST_IT',
  FETCH_ORDER_DELIVERY_STATUS_LIST_IT= 'FETCH_ORDER_DELIVERY_STATUS_LIST_IT',
  FETCH_ORDER_STATUS_CZ = 'FETCH_ORDER_STATUS_CZ'
}
